export const isMetricRegion = () => {
  // Get the user's locale (fall back to 'en-US' if not available)
  const locale = navigator.language || navigator.languages?.[0] || "en-US";
  // List of locales known to use imperial units
  const imperialLocales = ["en-US", "en-LR", "en-MY"]; // US, Liberia, Myanmar

  // Return true if the locale is not in the imperial list (i.e., likely metric)
  return !imperialLocales.includes(locale);
};

export const getSystemLanguageCode = (language = navigator.language) => {
  return language.substring(0, language.indexOf("-"));
};

export const checkLanguageExists = (lng = navigator.language, languages) => {
  const language = lng;
  return languages.some((language) => language.id === language);
};
